module.exports = __webpack_public_path__ + "static/media/m14cr823.4b0aaae2.png";